/** How a subscription reads in backstage Luuqa, in its tab and on a profile. */
const STORES = { APP_STORE: "App Store", MAC_APP_STORE: "App Store", PLAY_STORE: "Google Play", STRIPE: "Stripe", RC_BILLING: "Web", PROMOTIONAL: "Promotional" };

export const planLabel = (plan) => ({ bundle: "Bundle", luuqa: "Luuqa", music: "Heesify+" }[plan] ?? plan);

export const planClass = (plan) => (plan === "bundle" ? "bg-luuqa text-white" : "bg-luuqa/15 text-luuqa");

export const stateClass = (state) => ({
    active: "bg-emerald-500/15 text-emerald-400",
    cancelling: "bg-yellow-500/15 text-yellow-400",
    ended: "bg-nomad-800 text-nomad-100",
}[state]);

export const subscriptionPrice = (row) => {
    if (row.price === null || row.price === undefined) return null;
    return `${row.currency === "USD" || !row.currency ? "$" : `${row.currency} `}${row.price.toFixed(2)}`;
};

export const subscriptionStore = (row) => STORES[row.store] ?? row.store;

export const subscriptionPayments = (row) => (row.renewals > 1 ? `${row.renewals} payments` : null);

export const subscriptionDate = (row) => {
    if (!row.expires_at) return "";
    const day = new Date(row.expires_at).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
    return { active: `Renews ${day}`, cancelling: `Ends ${day}`, ended: `Ended ${day}` }[row.state];
};
